import React from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { format } from 'kn-react';
import './AppNav.css';

const waterWellCount = 1232719;


class AppNav extends React.Component {

  render(){
    const { children } = this.props;

    return (
      <React.Fragment>
        <Navbar fluid fixed="top">
          <Navbar.Header>
            <Navbar.Brand componentClass={Link} href="/" to="/" style={{ paddingTop: 5 }}>
              <img
                alt="Allied Water Well Log"
                src="/allied_logo.png"
                className="d-inline-block align-top"
              />
            </Navbar.Brand>

            <Navbar.Toggle/>

          </Navbar.Header>

          <Navbar.Collapse>
            <Nav>
              <NavItem componentClass={Link} href="/instructions" to="/instructions">Instructions</NavItem>
              <NavItem href="https://docs.google.com/spreadsheets/d/1f0g5JER94jZ56diUzyaZtTytrormYNlBiw32156_WCw/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Map Data</NavItem>
            </Nav>
            <Navbar.Text pullRight className="infoText">
              <span className="recordCount">
                { format.commas(waterWellCount) } Records in MD, NY, PA
              </span>
              <br/>
              <span className="kinertia">Built by <a href="https://www.kinertia.com" target="_blank" rel="noopener noreferrer">Kinertia</a></span>
            </Navbar.Text>
          </Navbar.Collapse>
        </Navbar>
        <div className="AppBody">
          { children || [] }
        </div>
      </React.Fragment>
    );
  }

}

export default AppNav;
